import { render, staticRenderFns } from "./AffectUserToAgencyModal.vue?vue&type=template&id=5d9f4a85&"
import script from "./AffectUserToAgencyModal.vue?vue&type=script&lang=js&"
export * from "./AffectUserToAgencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports